import { Component, Injectable, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BlankComponent } from "../blank/blank.component";

@Component({
  selector: 'app-spinner',
  template: `
    <app-dot-loader *ngIf="isBusy"></app-dot-loader>
  `
})
@Injectable({
  providedIn: 'root'
})
export class SpinnerComponent implements OnInit {
  isBusy: boolean;
  private dialogConfig = {
    disableClose: true,
    panelClass: 'hideBackground'
  };

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  openComponent(spin: boolean) {
    if (spin) {
      this.dialog.open(BlankComponent, this.dialogConfig);
    } else {
      this.dialog.openDialogs
        .filter(ref => ref.componentInstance instanceof BlankComponent)
        .forEach(ref => ref.close());
    }
  }

  spinnerAction = (spin: boolean, elementId?: string) => {
    this.openComponent(spin);
    if (spin) {
      this.isBusy = true;
    } else {
      this.isBusy = false;
    }
  }
}